class JbcProductDetails extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced === 'true') return;
    const normalize = (text) => text.trim().toLocaleLowerCase().replace(/\s+/g, ' ');
    const title = normalize(this.dataset.productTitle ?? '');
    const nodes = Array.from(this.childNodes);
    const headings = nodes.filter((node) => node.nodeType === 1 && /^H[23]$/.test(node.nodeName));
    if (this.querySelector('details')) {
      this.dataset.enhanced = 'true';
      return;
    }
    const headingTag = headings.some((heading) => heading.nodeName === 'H2') ? 'H2' : 'H3';
    const isSectionHeading = (node) => node.nodeType === 1 && node.nodeName === headingTag;
    const createPanel = (label) => {
      const panel = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = label;
      const content = document.createElement('div');
      content.className = 'jbc-product-detail__content';
      panel.append(summary, content);
      return { panel, content };
    };
    let current = null;
    let panels = 0;
    for (const node of nodes) {
      if (isSectionHeading(node)) {
        const label = node.textContent.trim();
        const heading = normalize(label);
        const isAlbumTitle = panels === 0 && heading.length > 4 && title.includes(heading);
        if (label && !isAlbumTitle) {
          current = createPanel(label);
          this.insertBefore(current.panel, node);
          node.remove();
          panels += 1;
          continue;
        }
      }
      if (current) current.content.append(node);
    }
    if (panels === 0 && this.textContent.trim()) {
      const fallback = createPanel(this.dataset.fallbackTitle);
      while (this.firstChild) fallback.content.append(this.firstChild);
      this.append(fallback.panel);
    }
    this.dataset.enhanced = 'true';
  }
}
if (!customElements.get('jbc-product-details')) {
  customElements.define('jbc-product-details', JbcProductDetails);
}
